import Perfil from "model/administracao/cadastro/Perfil";

export default class PerfilItemDashboard {
    id: number;
    codigoItem: string;
    perfil: Perfil|null;
    constructor(
        id: number = 0,
        codigoItem: string = "",
        perfil: Perfil|null = null
    ) {
        this.id = id;
        this.codigoItem = codigoItem;
        this.perfil = perfil;
    }
}